import React from 'react'
import { cn } from '../../../utils/classnames'

const CustomRadio = ({
  name,
  label,
  checked,
  onChange,
  disabled = false,
  labelClassName = '',
  radioClassName = ''
}) => {
  return (
    <label className="flex items-center gap-2 cursor-pointer select-none">
      <span
        className={cn(
          'w-5 h-5 flex-shrink-0 flex items-center justify-center border rounded-full border-bluePale',
          radioClassName
        )}
      >
        <span
          className={cn(
            'w-2.5 h-2.5 rounded-full',
            checked ? 'bg-tealLight' : 'bg-transparent'
          )}
        />
        <input
          type="radio"
          name={name}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          className="hidden"
        />
      </span>
      <span className={cn('text-blueDarker text-base', labelClassName)}>{label}</span>
    </label>
  )
}

export default CustomRadio
